<template>
<div class="page">
  <div class="page-content">
    <div class="row justify-content-center align-content-center align-items-center sesion-no-disponible">
      <i class="f7-icons text-color-gray">exclamationmark_triangle</i>
      <span class="titulo">Esta pantalla no está disponible ahora mismo</span>
      <span class="detalle">
        No se han podido comprobar tus permisos, así que la pantalla no se abre: hacerlo con los
        permisos de la última vez podría enseñar datos de personal a quien ya no debe verlos, o
        esconderlos a quien sí.
      </span>
      <span class="motivo" v-if="motivo">{{motivo}}</span>
      <a class="button button-fill button-large" @click="reintentar">Reintentar</a>
    </div>
  </div>
</div>
</template>
<script>
/**
 * #65 · Lo que se enseña cuando la barrera de `barreraUsuarioActualizado.js` no consigue el
 * usuario de esta carga: error, timeout o un cuerpo que no se sabe leer.
 *
 * Existe porque un fallo NO puede valer por «sigue valiendo lo de antes». Los permisos guardados
 * en el navegador son los de la sesión anterior, y decidir con ellos qué datos de un compañero se
 * enseñan es justo lo que la decisión de diseño del 01/10/2026 prohíbe.
 *
 * Hermano de `calendario/calendario-no-disponible.vue` (#49), que hace lo propio con el
 * interruptor de bloqueo: misma barrera, misma salida cuando no se sabe.
 */
export default {
  props: {
    /** URL que se intentaba abrir, para volver a intentarlo tal cual. */
    url: { type: String, default: '/' },
    /** Qué falló, dicho en una línea. Informativo: la acción siempre es la misma, reintentar. */
    motivo: { type: String, default: '' }
  },
  methods: {
    reintentar() {
      const router = this.$f7router
        || (this.$f7 && this.$f7.views && this.$f7.views.main && this.$f7.views.main.router);
      if (!router) return;
      // `reloadCurrent` para sustituir ESTA pantalla y no dejar el error en el historial, e
      // `ignoreCache` para que la ruta se resuelva otra vez —que es lo que vuelve a pedir el
      // usuario, porque la petición fallida no se guarda—.
      router.navigate(this.url, { reloadCurrent: true, ignoreCache: true });
    }
  }
}
</script>
<style scoped>
.sesion-no-disponible { min-height: 100%; flex-direction: column; text-align: center; padding: 24px; }
.sesion-no-disponible .f7-icons { font-size: 64px; }
.sesion-no-disponible .titulo { font-size: 1.2rem; font-weight: 600; margin-top: 12px; }
.sesion-no-disponible .detalle { max-width: 520px; margin-top: 8px; color: #6b7885; }
.sesion-no-disponible .motivo { margin-top: 8px; color: #6b7885; font-size: 0.85rem; font-style: italic; }
.sesion-no-disponible .button { margin-top: 20px; width: 180px; }
</style>
